var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModern(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1778,
    height: 1000,
    viewBox: "0 0 1778 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1777.78 -0.000643229H0V999.999H1777.78V-0.000643229Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 999.999H1777.78V-0.000976562H0V999.999Z",
    fill: "#0C131F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M567.073 -0.00072461L1777.78 849.172V569.133L965.006 -0.00072461H567.073Z",
    fill: "#91AED9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1244.56 -0.00072461L544.45 999.999H806.046L1508.03 -0.00072461H1244.56Z",
    fill: "#010204"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1221.71 -0.00072461L521.593 999.999H783.19L1485.17 -0.00072461H1221.71Z",
    fill: "#6D89B9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M285.94 -0.00072461L1711.68 999.999H1777.78V836.119L585.26 -0.00072461H285.94Z",
    fill: "#010204"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M320.239 -0.00072461L1745.98 999.999H1777.78V812.079L619.546 -0.00072461H320.239Z",
    fill: "#4874C0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1588.75 -0.00072461L890.343 999.999H1034.16L1731.41 -0.00072461H1588.75Z",
    fill: "#010204"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1566.63 -0.00072461L868.226 999.999H1012.04L1709.29 -0.00072461H1566.63Z",
    fill: "#3960A2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModern);
export default __webpack_public_path__ + "static/media/modern.56a484cd6751c66981692093dc386068.svg";
export { ForwardRef as ReactComponent };